import styled from 'styled-components';

import Field from 'assets/images/football_field.svg';

export default styled.div`
  width: 343px;

  .field {
    background-image: url(${Field});
    background-size: cover;
    background-position: center;
    height: 647px;
    width: 100%;
    display: grid;
    grid-template-rows: 50% 50%;
  }

  .home,
  .away {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(7, 1fr);
    grid-gap: 1px;
  }

  .substitutedOn {
    font-family: Overpass;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
    color: #323232;
    .substitutes {
      display: flex;
      flex-wrap: wrap;
      div {
        padding-right: 4px;
        padding-bottom: 2px;
      }
    }
    .substitutesHomeTeam {
      padding-bottom: 2px;
      align-items: left;
    }
  }

  select {
    width: 100%;
  }

  .test-1 {
    grid-column: 3;
    grid-row: 4;
  }
`;
